import { Injectable, inject } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { ContactInterface } from '@app/interfaces/contact.interface';
import { UserInterface } from '@app/interfaces/user.interface';
import { UsersService } from '@app/services/users.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { MortgageInterface } from '@app/interfaces/mortgage.interface';

export interface CheckDuplicityResponseContact {
    contactId: string;
    email: string;
}

export interface CheckDuplicityResponseNo {
    duplicity: boolean;
}

export interface DuplicityContactResponse {
    auth: {
        accessToken: string;
        authentication: any;
    };
    duplicity: boolean;
    user: UserInterface;
    userId: string;
}

export type CheckDuplicityResponse = CheckDuplicityResponseContact &
    CheckDuplicityResponseNo &
    DuplicityContactResponse;

export interface CheckEmailResponse {
    exist: boolean;
    isVerify: boolean;
    contactId: string;
}

@Injectable({ providedIn: 'root' })
export class ContactsService extends ApiService<ContactInterface> {
    private readonly usersService = inject(UsersService);
    private readonly httpClient = inject(HttpClient);

    protected serviceName = 'contacts';

    constructor() {
        super();

        this.initConnection();
        this.usersService.user$.subscribe((user: UserInterface) => {
            if (user?.contactId) {
                this.get(user.contactId).then((contact: ContactInterface) => {
                    if (contact) {
                        user.contact = contact;
                    }
                });
            }
        });
    }

    public verify(params = {}) {
        return this.backendService.getService('contacts/verify').find({ query: params });
    }

    public verifyCaptcha(params = {}) {
        // @API contacts/verifyphone.get
        const url = `${environment.url.backendApi}/contacts/verifyphone`;
        const query = new HttpParams({ fromObject: params });
        return this.httpClient.get<any>(url, { params: query }).toPromise();
    }

    public checkEmail(email: string, gcToken: string): Promise<CheckEmailResponse> {
        // @API contacts/check.get
        const url = `${environment.url.backendApi}/contacts/check`;
        const query = new HttpParams({
            fromObject: {
                sendLoginEmail: true,
                email,
                gcToken,
            },
        });
        return this.httpClient.get<CheckEmailResponse>(url, { params: query }).toPromise();
    }

    public async checkDuplicity(mortgage: MortgageInterface): Promise<CheckDuplicityResponse> {
        // @API contacts/duplicity.find
        return this.backendService.getService('contacts/duplicity').find({
            query: {
                dealId: mortgage._id,
                countryCode: '+420',
                phoneNumber: mortgage._contacts[0].phone[0].number,
                contactId: mortgage._contacts[0]._id,
            },
        }) as Promise<CheckDuplicityResponse>;
    }

    public async getDuplicity(
        contactId: string,
        email: string,
        mortgage: MortgageInterface
    ): Promise<DuplicityContactResponse> {
        // @API contacts/duplicity.get
        return this.backendService.getService('contacts/duplicity').get(contactId, {
            query: {
                dealId: mortgage._id,
                email,
            },
        }) as Promise<DuplicityContactResponse>;
    }

    protected _updated(item: any): void {
        console.log('ContactsService._updated', item); //TODO REMOVE
        this.itemSubject.next(item);
        if (this.usersService.currentUser()?.contactId === item._id) {
            this.usersService.setCurrentUser({ ...this.usersService.currentUser(), contact: item });
        }
    }
}
